module.exports = __webpack_public_path__ + "img/d-and-h-logo.ef3da400.png";